import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-512602d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-header" }
const _hoisted_2 = { class: "box-search" }
const _hoisted_3 = { class: "grid grid-nogutter" }
const _hoisted_4 = { class: "col-6 flex align-items-center flex-wrap gap-2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "p-input-icon-left h-auto"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "col-6 flex justify-content-end" }
const _hoisted_9 = { class: "flex align-items-center" }

import Button from "primevue/button";

import { withDefaults, ref } from "vue";

type ITools = {
  enableTitle?: boolean;
  enableSearch?: boolean;
  enableExport?: boolean;
  enableImport?: boolean;
  enableCreate?: boolean;
  createButtonLabel?: string;
  searchPlaceholder?: string;
  searchValue?: string;
  titleLabel?: string;
  titleClass?: string;
  titleStyle?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    enableTitle: { type: Boolean, default: false },
    enableSearch: { type: Boolean, default: false },
    enableExport: { type: Boolean, default: false },
    enableImport: { type: Boolean, default: false },
    enableCreate: { type: Boolean, default: true },
    createButtonLabel: { default: "顧客新規作成" },
    searchPlaceholder: { default: "カルテNo.、お名前" },
    searchValue: null,
    titleLabel: null,
    titleClass: null,
    titleStyle: null
  },
  emits: ["search", "new", "import", "export", "fileChange"],
  setup(__props: any, { emit: emits }) {

const uploadFileCsv = ref();
const importButton = ref();





const onSearch = (event: Event) => emits("search", event);
const onNew = (event: Event) => emits("new", event);
const onImport = (event: Event) => emits("import", event, uploadFileCsv);
const onExport = (event: Event) => emits("export", event);
const fileChange = (event: Event) => emits("fileChange", event, importButton, uploadFileCsv);

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (__props.enableTitle)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(__props.titleClass),
                style: _normalizeStyle(__props.titleStyle),
                innerHTML: __props.titleLabel
              }, null, 14, _hoisted_5))
            : _createCommentVNode("", true),
          (__props.enableSearch)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_InputText, {
                  placeholder: __props.searchPlaceholder,
                  onKeyup: _withKeys(onSearch, ["enter"]),
                  modelValue: __props.searchValue
                }, null, 8, ["placeholder", "onKeyup", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "otherSearchButtons")
        ]),
        _createElementVNode("div", _hoisted_8, [
          (__props.enableExport)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                label: "ダウンロード",
                icon: "icon-lms_download",
                class: "m-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onExport($event)))
              }))
            : _createCommentVNode("", true),
          (__props.enableImport)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                label: "インポート",
                ref_key: "importButton",
                ref: importButton,
                icon: "icon-lms_upload",
                class: "m-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onImport($event, uploadFileCsv.value)))
              }, null, 512))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "file",
            accept: ".csv",
            class: "hidden",
            ref_key: "uploadFileCsv",
            ref: uploadFileCsv,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (fileChange($event, importButton.value, uploadFileCsv.value)))
          }, null, 544),
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "otherButtons"),
            (__props.enableCreate)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  label: __props.createButtonLabel,
                  class: "mr-0 btn-orange",
                  onClick: onNew
                }, null, 8, ["label"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})